import React from 'react'
import { GLBModel } from '../../GLBModel'
import type { DecorationsProps } from '../types'

export const Decorations: React.FC<DecorationsProps> = ({ onBackgroundClick }) => (
  <GLBModel
    modelUrl="/cdn/3d/room7-optimized.glb"
    modelPosition={[50, -10, -15]}
    modelScale={[120, 120, 120]}
    modelRotation={[-Math.PI, 0, Math.PI]}
    shouldCastShadow
    shouldReceiveShadow
    onClick={onBackgroundClick}
    userData={{ isRoom: true }}
  />
)
